import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubmitdataService } from "src/app/services/submitdata/submitdata.service";
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { GisService } from 'src/app/services/gis/gis.service';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { ToastrService } from 'ngx-toastr';
import { timeStamp } from 'console';
import { element } from 'protractor';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'app-viewmodal-report',
  templateUrl: './viewmodal-report.component.html',
  styleUrls: ['./viewmodal-report.component.css']
})
export class ViewmodalReportComponent implements OnInit {
  @Input() ay;
  @Input() subtimeperiod;
  @Input() distname;
  @Input() labeldata
  @Input() weightdata;
  @Input() distuuid;
  hierarchyData: any = [];
  hardcodeAttTableData: any = [
    { officials: "District Collector", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Representative from municipalities", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Representative from gram panchayats", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Representative from Public Works", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Representative from Irrigation", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Representative from Public Health Engineering", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Representative from Rural Drinking Water Department", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Representative from State Pollution Control Board", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "District official to be nominated by DC", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Divisional Forest Officer", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Environmentalists associated with River Ganga protection", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' },
    { officials: "Representative of local industry", post: "", name: "", contactno: "", emailid: "", attendance: '', gender: '' }
  ];
  themeData: any;
  meetingmoduleData: any[];
  dropdownlist: any = [];
  activeSpinner: boolean;
  labelName: any = [];
  postName: any = [];
  stakeholder: any = [];
  emailid: any = [];
  mobileNum: any = [];
  attendList: any = [];
  dateformat: any = [];
  minutelist: any = [];
  dataObj: {};
  meetingData: any = [];
  filterList = []
  tabledataFormat: any[];
  descriptedData: any[];
  monthsmap: any;
  showfileButton: any;
  filedata: any;
  filedataObj: any;
  showimgbutton: boolean;
  subfileobj: any;
  subfilehide: boolean;
  subimgobj: any;
  subimghide: boolean;
  showthemedownload: boolean;
  stateObj: {};
  tableData: any;
  themeBelement: any = [];
  scoreData: any;
  totalScore: any;
  replaceMoMFile: any = { 'file1': null, 'file2': null };
  meetingfilesData: any = {};
  momentered: boolean;
  modalRef: any;
  userDetails:any;
  showMomButton:boolean
  @ViewChild('dataSubmissionModal', {}) dataSubmissionModal;

  constructor(
    private submitdataSerivce: SubmitdataService,
    private constants: ConstantsModule,
    private utils: UtilsModule,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private logsrv: AuthloginService,
    private toastr: ToastrService,) { }

  ngOnInit() {
    this.userDetails = this.logsrv.checkloginstatus();
    if(this.userDetails){
     if(this.userDetails['roles'][1] == "Ed_admin" || this.userDetails['roles'][1] == "nmcg_admin"){
      this.showMomButton  = true;
     } else{
      this.showMomButton = false
     }
    }

    this.getTabledata();
    // console.log(this.labeldata);
    this.labeldata.forEach(element => {
      if (this.subtimeperiod == element['key']) {
        this.monthsmap = element['value']
      }
    });
    //this.getThemesData();

  }
  // getThemesData(){
  // console.log('ay',this.ay);
  // let option={
  // "ay": this.ay,
  // // "lu" : this.distuuid,
  // // 'datasubmit': 'mothwise',

  // }
  // this.submitdataSerivce.FetchIndicators(option).subscribe(data =>{
  // this.themeData = []; 
  // data.forEach(theme => {
  // if (theme['label'] != null && theme['label'] != 'Meeting at DGC ') {
  // this.themeData.push(theme);
  // // console.log('themechildlist',theme['childList'].length);
  // if (theme['childList']!=null){
  // //console.log('theme',theme['entityUUID']);
  // theme['childList'].forEach(indicator=>{
  // if (indicator['childList']!=null){
  // //console.log('indicator',indicator['aeid']);
  // indicator['childList'].forEach(subindicator=>{
  // //console.log('sub-ind-',subindicator['entityUUID']);

  // })
  // }

  // })
  // }
  // }
  // });
  // console.log('themedata',this.themeData);
  // })

  // }
  getTabledata() {
    this.descriptedData = [];
    let reportdata = {
      "ay": this.ay,
      "view": this.constants.VIEWS['admin'],
      "component": 1,
      "cType": this.constants.LOCATION_CONSTANT['DISTRICT'],
      "lu": this.distuuid,
      "subTp": this.subtimeperiod,
      "userId": "1"
    }
    this.activeSpinner = true;
    this.submitdataSerivce.getrawdata(reportdata).subscribe(rawdata => {
      this.activeSpinner = false;
      this.meetingData = rawdata;
      let item = rawdata['meetings'];
      Object.keys(item).forEach(tp => {
        let data = {};
        if (item[tp]['date'] != null) {
          data['dateObj'] = item[tp]['date'];
        } else {
          data['dateObj'] = ''
        }
        if (item[tp]['description'] != "[]") {
          let label = item[tp]['description'].split("[");
          let labels = label[1].split("]");
          data['desc'] = labels;
        } else {
          data['desc'] = '';
        }
        data['mom'] = item[tp]['mom'];
        this.descriptedData.push(data);
      })
      this.getScoresData(rawdata);
      // this.formatTableData(rawdata);
      this.formatMeetingTableData(rawdata);
    });

  }

  getScoresData(rawdata) {
    let options = {
      "lu": "[" + JSON.stringify(this.distuuid) + "]",
      "indicator": JSON.stringify(rawdata['indicatorUuids']),
      "ay": this.ay,
      "view": this.constants.VIEWS['admin'],
      "subTp": this.subtimeperiod,
      "component": this.constants.COMPONENT["ACTUAL_DATA"],
      "approval_level": 1,
      "verific_status": 1,
      "cType": this.constants.LOCATION_CONSTANT['DISTRICT']
    };
    this.submitdataSerivce.getCustomRankingData(options).subscribe(res => {
      this.scoreData = res['data'];
      this.totalScore = 0;
      for (let key in this.scoreData) {
        this.totalScore = this.totalScore + parseFloat(this.scoreData[key][0]['actualData']);
        // console.log("totall",this.totalScore,parseFloat(this.scoreData[key][0]['actualData']));
      }
      this.formatTableData(rawdata);
    })
  }

  formatMeetingTableData(rawdata: any) {
    this.tabledataFormat = [];
    let attendanceMeetings = {};
    let count = 0;
    attendanceMeetings = rawdata['meetings'];
    if (Object.keys(attendanceMeetings).length > 0) {
      Object.keys(attendanceMeetings).forEach(date => {
        let attdata = JSON.parse(attendanceMeetings[date]['attendance']);
        this.hidefileOBj(attdata);
        this.hideimgObj(attdata);
        this.hidesubFile(attdata);
        this.hidesubImage(attdata)
        let parseobj = JSON.parse(attdata['data']);
        Object.keys(parseobj).forEach(item => {
          Object.keys(parseobj[item]).forEach(kval => {
            if (parseobj[item][kval] != '') {
              count = count + 1;
            }
          })

          this.tabledataFormat.push(parseobj[item]);
        })
      })
    }

    if (count == 0) {
      this.tabledataFormat = this.hardcodeAttTableData;
    }
  }

  hidesubImage(attdata: any) {
    this.subimgobj = attdata['image_a'];
    if (this.subimgobj) {
      this.subimghide = true;
    } else {
      this.subimghide = false;
    }
  }
  hidesubFile(attdata: any) {
    this.subfileobj = attdata['document_a'];
    if (this.subfileobj) {
      this.subfilehide = true;
    } else {
      this.subfilehide = false;
    }
  }
  hidefileOBj(data) {
    this.filedata = data['document'];
    if (this.filedata) {
      this.showfileButton = true;
    } else {
      this.showfileButton = false;
    }
  }
  hideimgObj(data) {
    this.filedataObj = data['image'];
    if (this.filedataObj) {
      this.showimgbutton = true;
    } else {
      this.showimgbutton = false;
    }
  }
  formatdate(date) {
    return this.utils.getDateInFormatFromModelDate(date.toString(), "dd-MM-yyyy")

  }
  formatTableData(rawdata) {
    // console.log('rawdataaaaaa',rawdata);
    let option = {
      "ay": this.ay,
      // "lu" : this.distuuid,
      // 'datasubmit': 'mothwise',
    }
    let count = 0;
    //console.log('rawdata=',rawdata['buzdata'],'length=',rawdata['buzdata'].length);
    this.hierarchyData = [];
    let themeBpush = false;
    let sno = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    this.submitdataSerivce.FetchIndicators(option).subscribe(data => {
      data.forEach(theme => {

        if (theme['sno'].charCodeAt(0) >= 66 && this.themeBelement.length > 0 && themeBpush == false) {
          this.themeBelement.forEach(list => {
            this.hierarchyData.push(list);
          })
          themeBpush = true;
        }
        let themePushed: boolean = false;
        if (theme['childList'] != null) {

          theme['childList'].forEach(indicator => {
            let indicatorPushed = false;
            Object.values(rawdata['indicatorUuids']).forEach(indID => {
              if (indicator['childList'] != null) {
                // console.log('indicaotrrrrrrr',indicator);
                indicator['childList'].forEach(subindicator => {
                  // console.log("subbbb",subindicator);
                  if (indID == indicator['entityUUID']) {
                    let item = {};
                    if (themePushed == false) {
                      let headTheme = {}
                      headTheme['name'] = theme['label'];
                      headTheme['sno'] = theme['sno'];
                      headTheme['type'] = theme['type'];
                      headTheme['entityUUID'] = theme['entityUUID'];
                      // headTheme['dataExists']=true;
                      this.hierarchyData.push(headTheme);
                      themePushed = true;
                    }
                    //console.log("roww",indID,indicator);
                    if (rawdata['buzActData'][indicator['entityUUID']] != "null") {
                      item['name'] = indicator['label'];
                      item['val'] = rawdata['buzActData'][indicator['entityUUID']];
                      item['uuid'] = indicator['entityUUID'];
                      item['sno'] = indicator['sno'];
                      item['score'] = this.scoreData[indicator['entityUUID']] ? this.scoreData[indicator['entityUUID']][0]['actualData'] : "-";
                      indicatorPushed = true;
                      if (rawdata['ActFileUUIDs'][indicator['entityUUID']]['fileUUID'] != null) {
                        item['fileUUID'] = rawdata['ActFileUUIDs'][item['uuid']]['fileUUID'];
                      }

                      if (!this.hierarchyData.some(data => data.uuid === item['uuid'])) {
                        //console.log("item in !=null", item, item['name'], indicator['sno']);
                        this.hierarchyData.push(item);

                        if (item['sno'] == "5.2") {
                          let yesTabId = "757a7328-2ec9-4c58-97b1-3acf6a155774";
                          let noTabId = "1122dd8d-33cd-4c54-af8e-8039dd051089";
                          let spItem = {};

                          if (Object.keys(rawdata['buzdata']).includes(yesTabId) && Object.keys(rawdata['buzdata']).includes(noTabId)) {
                            // console.log("insideeee no table"); 
                            let i = 0;
                            rawdata['buzdata'][noTabId].forEach(microInd1 => {
                              spItem = microInd1;
                              spItem['subindId'] = noTabId;
                              spItem['name'] = item['name'];
                              spItem['type'] = 'HARDCODE';
                              spItem['tabType'] = 'nonfunctional';
                              spItem['sno'] = sno[i];
                              // console.log("microind in nooo1",spItem);
                              this.hierarchyData.push(spItem);
                              i = i + 1;
                            })

                            i = 0;
                            rawdata['buzdata'][yesTabId].forEach(microind2 => {
                              spItem = microind2;
                              spItem['subindId'] = noTabId;
                              spItem['name'] = item['name'];
                              spItem['type'] = 'HARDCODE';
                              spItem['tabType'] = 'functional';
                              spItem['sno'] = sno[i];
                              // console.log("microind in nooo2",spItem);
                              this.hierarchyData.push(spItem);
                              i = i + 1;
                            })

                          } else if (Object.keys(rawdata['buzdata']).includes(yesTabId)) {
                            // console.log("inside yes tableeeee",rawdata['buzdata'][yesTabId]);
                            let i = 0;
                            rawdata['buzdata'][yesTabId].forEach(microind => {
                              spItem = microind;
                              spItem['subindId'] = yesTabId;
                              spItem['name'] = item['name'];
                              spItem['type'] = 'HARDCODE';
                              spItem['sno'] = sno[i];
                              // console.log("microind in yess",spItem);
                              this.hierarchyData.push(spItem);
                              i = i + 1;
                            })
                          }
                        }
                      }

                      if (Object.keys(rawdata['buzdata']).includes(indicator['entityUUID']) && rawdata['buzdata'][indicator['entityUUID']] != null) {
                        if (rawdata['buzdata'][indicator['entityUUID']] != null) {
                          rawdata['buzdata'][indicator['entityUUID']].forEach(subInd => {
                            let sUBiND = rawdata['buzdata'][indicator['entityUUID']][subInd];
                            if (subInd['id'] == subindicator['entityUUID']) {
                              // if (indicatorPushed==false){
                              // let indicatorObj={};
                              // indicatorObj['name']=indicator['name'];
                              // indicatorObj['sno']=indicator['sno'];
                              // indicatorObj['type']= indicator['type'];
                              // // console.log('indicatorpushhhh',indicator['name'],indicator['sno']);
                              // }
                              let item = {};
                              item['name'] = subindicator['label'];
                              item['val'] = subInd['value'];
                              item['uuid'] = subindicator['entityUUID'];
                              item['sno'] = subindicator['sno'];
                              if (subInd['fileUUID'] != undefined) {
                                item['fileUUID'] = subInd['fileUUID'];
                              } else item['fileUUID'] = '';

                              //console.log("item in !=null subind", item, item['name'], subindicator['sno']);
                              this.hierarchyData.push(item);
                            }
                          })
                        }
                      }

                    } else if (rawdata['buzActData'][indicator['entityUUID']] == "null") {
                      Object.keys(rawdata['buzdata'][indicator['entityUUID']]).forEach(subInd => {
                        let sUBiND = rawdata['buzdata'][indicator['entityUUID']][subInd];
                        if (sUBiND['id'] == subindicator['entityUUID']) {
                          if (indicatorPushed == false && indicator['sno'] != '1.2' && indicator['sno'] != '1.4' && indicator['sno'] != '2.1') {
                            let indicatorObj = {};
                            indicatorObj['name'] = indicator['label'];
                            indicatorObj['sno'] = indicator['sno'];
                            indicatorObj['val'] = "-";
                            indicatorObj['type'] = indicator['type'];
                            indicatorObj['uuid'] = indicator['entityUUID'];
                            indicatorObj['score'] = this.scoreData[indicator['entityUUID']] ? this.scoreData[indicator['entityUUID']][0]['actualData'] : "-";
                            indicatorPushed = true;
                            //console.log("item in ==null & !=2.1,1.2",indicatorObj,indicatorObj['name'],indicatorObj['sno']); 
                            this.hierarchyData.push(indicatorObj);
                          } else if (indicator['sno'] == '2.1' && indicatorPushed == false) {
                            let indicatorObj = {};
                            indicatorObj['name'] = indicator['label'];
                            indicatorObj['sno'] = '2.10';
                            indicatorObj['val'] = "-";
                            indicatorObj['type'] = indicator['type'];
                            indicatorObj['uuid'] = indicator['entityUUID'];
                            indicatorObj['score'] = this.scoreData[indicator['entityUUID']] ? this.scoreData[indicator['entityUUID']][0]['actualData'] : "-";
                            indicatorPushed = true;
                            //console.log("item in ==null & ==2.1",indicatorObj,indicatorObj['name'],indicatorObj['sno']);
                            this.themeBelement.push(indicatorObj);
                          } else if (indicator['sno'] == '1.2' || indicator['sno'] == '1.4') {
                            item['score'] = this.scoreData[indicator['entityUUID']] ? this.scoreData[indicator['entityUUID']][0]['actualData'] : "-";
                          }
                          item['name'] = subindicator['label'];
                          item['val'] = sUBiND['value'];
                          item['uuid'] = subindicator['entityUUID'];
                          item['sno'] = subindicator['sno'];
                          if (sUBiND['fileUUID'] != undefined) {
                            item['fileUUID'] = sUBiND['fileUUID'];
                          }
                          if (indicator['sno'] == '2.1') {
                            // console.log("==2.1 themeBeleme",item,item['name'],item['sno']); 
                            this.themeBelement.push(item);
                          } else {
                            // console.log("else 2.1 hierarchyData",item,item['name'],item['sno']);
                            this.hierarchyData.push(item);

                            if (item['name'] == "Mass awareness meetings held (If Yes- No of meetings held)" && item['val'] == "yes") {
                              let cmtItem = {};
                              cmtItem['name'] = "Number of meetings held";
                              cmtItem['type'] = "COMMENT";
                              cmtItem['val'] = sUBiND['nomh'];
                              // console.log("1.1 b comment",cmtItem)
                              this.hierarchyData.push(cmtItem);
                            }

                            if (item['name'] == "Revenue generation activities on the Ghats") {
                              let spItem = {};
                              spItem['name'] = "Whether Revenue Generation is used for O&M of ghats";
                              spItem['sno'] = "d.1";
                              spItem['val'] = sUBiND['wrg'];
                              this.hierarchyData.push(spItem);
                            }
                          }
                          // console.log("item in ==null", item, item['name'], subindicator['sno']);
                        }
                      })
                    }
                  }
                })
              } else {
                if (indID == indicator['entityUUID']) {
                  if (themePushed == false) {
                    let headTheme = {}
                    headTheme['name'] = theme['label'];
                    headTheme['sno'] = theme['sno'];
                    headTheme['type'] = theme['type'];
                    headTheme['entityUUID'] = theme['entityUUID'];
                    // headTheme['dataExists']=true;
                    this.hierarchyData.push(headTheme);
                    themePushed = true;
                  }
                  let item = {};
                  if ((indicator['sno'] == '5.5' || indicator['sno'] == '5.7') && indicatorPushed == false) {
                    let indicatorObj = {}
                    indicatorObj['name'] = indicator['label'];
                    indicatorObj['val'] = rawdata['buzActData'][indicator['entityUUID']];
                    indicatorObj['uuid'] = indicator['entityUUID'];
                    indicatorObj['sno'] = indicator['sno'];
                    indicatorObj['score'] = this.scoreData[indicatorObj['uuid']] ? this.scoreData[indicatorObj['uuid']][0]['actualData'] : "-";
                    indicatorPushed = true;
                    if (rawdata['ActFileUUIDs'][indicatorObj['uuid']]['fileUUID'] != null) {
                      // item['fileUUID'] = rawdata['ActFileUUIDs'][indicatorObj['uuid']]['fileUUID'];
                      indicatorObj['fileUUID'] = rawdata['ActFileUUIDs'][indicatorObj['uuid']]['fileUUID'];
                    }
                    // console.log("==5.5,5.7",indicatorObj,indicatorObj['name'],indicatorObj['sno']);

                    this.hierarchyData.push(indicatorObj);
                  }
                  //entering child data
                  if (rawdata['buzActData'][indicator['entityUUID']] != "null") {
                    let asciiCode = 97;
                    if (Object.keys(rawdata['buzdata']).includes(indicator['entityUUID'])) {
                      if (rawdata['buzdata'][indicator['entityUUID']] != null) {
                        Object.keys(rawdata['buzdata'][indicator['entityUUID']]).forEach(subInd => {
                          let sUBiND = rawdata['buzdata'][indicator['entityUUID']][subInd];
                          item = sUBiND;
                          // console.log('subindiiiii',sUBiND,indicator['sno']);
                          item['name'] = indicator['label'];
                          if (indicator['sno'] == '5.5' || indicator['sno'] == '5.7') {
                            item['type'] = 'HARDCODE'
                            item['sno'] = String.fromCharCode(asciiCode);
                            // item['val']=rawdata['buzActData'][indicator['entityUUID']];
                            asciiCode = asciiCode + 1;
                            // console.log("==5.5,5.7 buzact != null",item,item['name'],item['sno']); 
                            this.hierarchyData.push(item);
                          }
                          // console.log("item in no child !=null subind", item, item['name'], indicator['sno']);
                        })
                      }
                    }
                    if (indicator['sno'] != '5.5' && indicator['sno'] != '5.7') {
                      item['name'] = indicator['label'];
                      item['val'] = rawdata['buzActData'][indicator['entityUUID']];
                      item['uuid'] = indicator['entityUUID'];
                      item['sno'] = indicator['sno'];
                      item['score'] = this.scoreData[indicator['entityUUID']] ? this.scoreData[indicator['entityUUID']][0]['actualData'] : "-";
                      indicatorPushed = true;
                      if (rawdata['ActFileUUIDs'][item['uuid']]['fileUUID'] != null) {
                        item['fileUUID'] = rawdata['ActFileUUIDs'][item['uuid']]['fileUUID'];
                      }

                      // console.log("item in no child !=null", item, item['name'], indicator['sno']);
                      if (item['sno'] == '2.11') {
                        this.themeBelement.push(item);
                      }
                      else {
                        // console.log("!=5.5,5.7 != null",item,item['name'],item['sno']); 
                        this.hierarchyData.push(item);

                        if (item['sno'] == '2.2' && item['val'] == 'yes' && rawdata['businessData'][item['uuid']]['cmt'] != null) {
                          let cmtItem = {};
                          cmtItem['name'] = "Frequency of Cleaning";
                          cmtItem['val'] = rawdata['businessData'][item['uuid']]['cmt']['foc'];
                          cmtItem['type'] = 'COMMENT';
                          // console.log("2.2 yes comment",cmtItem);
                          this.hierarchyData.push(cmtItem);
                        }

                        if (item['sno'] == '6.2' && item['val'] == 'yes' && rawdata['businessData'][item['uuid']]['cmt'] != null) {
                          let cmtItem1 = {};
                          cmtItem1['name'] = "Number of meetings held";
                          cmtItem1['val'] = rawdata['businessData'][item['uuid']]['cmt']['nomh'];
                          cmtItem1['type'] = 'COMMENT';
                          // console.log("6.2 yes comment-1",cmtItem1); 
                          this.hierarchyData.push(cmtItem1);

                          let cmtItem2 = {};
                          cmtItem2['name'] = "Name of Industries";
                          cmtItem2['val'] = rawdata['businessData'][item['uuid']]['cmt']['noi'];
                          cmtItem2['type'] = 'COMMENT';
                          // console.log("6.2 yes comment-2",cmtItem2); 
                          this.hierarchyData.push(cmtItem2);
                        }
                      }
                    }

                  } else if (rawdata['buzActData'][indicator['entityUUID']] == "null") {
                    let asciiCode = 97;
                    Object.keys(rawdata['buzdata'][indicator['entityUUID']]).forEach(subInd => {

                      let sUBiND = rawdata['buzdata'][indicator['entityUUID']][subInd];
                      // console.log("subinds",sUBiND,indicator['entityUUID']);
                      item = sUBiND;
                      if (item && indicatorPushed == false) {
                        let indicatorObj = {};
                        indicatorObj['name'] = indicator['label'];
                        indicatorObj['sno'] = indicator['sno'];
                        indicatorObj['val'] = "*";
                        indicatorObj['type'] = indicator['type'];
                        indicatorObj['uuid'] = indicator['entityUUID'];
                        indicatorObj['score'] = this.scoreData[indicatorObj['uuid']] ? this.scoreData[indicator['entityUUID']][0]['actualData'] : "-";
                        // console.log("buzact == null indpushed=false",indicatorObj,indicatorObj['name'],indicatorObj['sno']);
                        this.hierarchyData.push(indicatorObj);
                        indicatorPushed = true;
                      }
                      item['name'] = indicator['label'];
                      item['sno'] = String.fromCharCode(asciiCode);//sUBiND['serialNo'] ;
                      item['type'] = "HARDCODE";
                      asciiCode = asciiCode + 1;

                      // if(sUBiND['id'] == subindicator['entityUUID']){
                      // item['name'] = subindicator['label'];
                      // item['val'] = sUBiND['value'];
                      // item['uuid'] = subindicator['entityUUID'];
                      // item['fileUUID'] = sUBiND['fileUUID'];
                      // console.log("item in no child ==null", item, item['name'], indicator['sno']);
                      this.hierarchyData.push(item);
                      // }
                    })
                  }
                }

              }
            })
          })
        }

      })

      // console.log("final op",this.hierarchyData); 
    })
  }

  getDownloadFiles(uuid, fileid) {
    this.activeSpinner = true;
    let downloadedpostdata = {
      "fileUUID": fileid,
      "id": uuid
    }
    this.submitdataSerivce.downloadExcelDatas(downloadedpostdata).subscribe(result => {
      // console.log("typee",result); 
      this.activeSpinner = false;
      if (!Array.isArray(result)) {
        let fname = 'report'
        if (result.type != "application/json") {
          switch (result.type) {
            case 'image/png': {
              fname += '.png'
              break;
            }
            case 'application/excel': {
              fname += '.xlsx'
              break;
            }
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
              fname += '.xls'
              break;
            }
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
              fname += '.docx'
              break;
            }
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
              fname += '.pptx'
              break
            }
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
              fname += '.ppt'
              break
            }
            case 'image/jpeg': {
              fname += '.jpeg'
              break;
            }
            case 'text/plain': {
              fname += '.txt'
              break;
            }
            case 'application/pdf': {
              fname += '.pdf'
              break;
            }
            case 'image/jpg': {
              fname += '.jpg'
              break;
            }
            case 'application/octet-stream': {
              fname += '.jpg'
              break;
            }
            default: {
              break;
            }
          }

          this.utils.downloadFile(result, fname);
        } else {
          this.toastr.error("some exception occured")
        }
      }
    })
  }

  fileupload(event, file, fileInput: HTMLInputElement) {
    if (event.target.files.length > 0) {
      // this.filename = event.target.files[0].name;

      if (this.fileNameCheck(event.target.files[0].name)) {
        this.replaceMoMFile[file] = event.target.files[0];
      } else {
        this.replaceMoMFile[file] = null;
        fileInput.value = '';
      }
    } else {
      this.replaceMoMFile[file] = null;
    }
    this.modalRef = this.modalService.open(this.dataSubmissionModal, { centered: true, backdrop: 'static', keyboard: false });
  }

  fileNameCheck(filename) {
    filename = filename.split('.');
    if (filename[filename.length - 1] === 'pdf' || filename[filename.length - 1] === 'PDF') {
      return true;
    } else {
      return false;
    }
  }

  replaceMoM() {
    let filedata = this.replaceMoMFile['file1'];
    // let imagedata = this.imageFiles;
    let filedata2 = this.replaceMoMFile['file2'];
    // let imagedata2 = this.multipleimgUpload;
    let postdata = {};
    postdata['document'] = filedata;
    // postdata['image'] = imagedata['photo'];
    postdata['document_a'] = filedata2;
    // postdata['image_a'] = imagedata2['photo'];
    // console.log("before status");

    if (this.replaceMoMFile['file1'] != null || this.replaceMoMFile['file2'] != null) { //this.imageFiles['photo']!=null
      this.momentered = true;
    };

    if (this.momentered) {
      // console.log("after status");
      this.submitdataSerivce.uploadFile(postdata).subscribe(data => {
        this.meetingfilesData = data['data'];
        // if (!isNullOrUndefined(data)) {
        if (data.status) {
          this.toastr.success(data.msg);
          this.updateMoM(this.meetingfilesData, this.replaceMoMFile);
        } else if (data.statuscode == 420) {
          this.logsrv.logoutuserandsessionclear();
        } else {
          if (data.msg == "File size exceeded for indicator id :document") {
            this.toastr.error("File size exceeds 5MB")
          } else {
            this.toastr.error("Some Exception Occurred")
          }
        }

      });
    } else {
      this.toastr.error("Please upload file in pdf format")
    }
    this.modalRef.dismiss();
  }

  updateMoM(data, fileNum) {
    let fileType = Object.keys(data)[0];
    console.log("aaa postdattt", data, Object.keys(data)[0], data[fileType]);

    let postdata = {
      "ay": this.ay,
      "month": this.subtimeperiod,
      "uuid": this.distuuid,
      "fileType": fileType,
      "fileUUID": data[fileType]
    };

    this.submitdataSerivce.changeMoMDocument(postdata).subscribe(data => {
      console.log("aaa changemom inside", data);
      if (data.status) {
        this.toastr.success("File Replaced Successfully");
        this.activeModal.dismiss('cancel click');
      } else {
        this.toastr.error("Some Exception Occurred")
      }
    })

  }

  closeReplaceModal() {
    this.replaceMoMFile['file1'] = null;
    this.replaceMoMFile['file2'] = null;
    this.meetingfilesData = {};
    this.modalRef.dismiss();
  }

  CheckValue(value) {
    if (value == "null" || value == 'undefined') {
      // this.hideRow = true
      return '';
    }
    return value;
  }

  checkNumOrAlpha(value) {
    if (isNaN(value)) {
      if (value == 'yes' || value == 'no')
        // this.hideRow = false
        return true
    } else {
      // this.hideRow = false
      return false
    }
  }
  downloadFiles() {
    let attdata: any;
    let filesObj = {};
    let obj = {};
    obj = this.meetingData['meetings'];
    Object.keys(obj).forEach(key => {
      attdata = JSON.parse(obj[key]['attendance']);
    });
    filesObj['fileUUID'] = attdata['document'];
    this.submitdataSerivce.downloadExcelDatas(filesObj).subscribe(data => {
      if (!Array.isArray(data)) {
        let fname = this.distname + "district Meeting report" + "_" + this.ay + this.monthsmap;
        if (data.type == "application/pdf" || data.type == "application/octet-stream") {
          switch (data.type) {
            case 'image/png': {
              fname += '.png'
              break;
            }
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
              fname += '.docx'
              break;
            }
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
              fname += '.pptx'
              break
            }
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
              fname += '.ppt'
              break
            }
            case 'application/octet-stream': {
              // fname+='.jpg'
              fname += '.pdf'
              break;
            }
            case 'application/excel': {
              fname += '.xlsx'
              break;
            }
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
              fname += '.xls'
              break;
            }
            case 'image/jpeg': {
              fname += '.jpeg'
              break;
            }
            case 'text/plain': {
              fname += '.txt'
              break;
            }
            case 'application/pdf': {
              fname += '.pdf'
              break;
            }
            case 'image/jpg': {
              fname += '.jpg'
              break;
            }
            default: {
              break;
            }
          }

          this.utils.downloadFile(data, fname);

        } else {
          this.toastr.error("some exception occured")
        }


      }

    })
  }
  downloadimageFormat() {
    let attdata: any;
    let filesObj = {};
    let obj = {};
    obj = this.meetingData['meetings'];
    Object.keys(obj).forEach(key => {
      attdata = JSON.parse(obj[key]['attendance']);
    });
    filesObj['fileUUID'] = attdata['image'];
    this.submitdataSerivce.downloadExcelDatas(filesObj).subscribe(data => {
      // console.log(data.type)
      if (!Array.isArray(data)) {
        let fname = this.distname + "district Meeting Image" + "_" + this.ay + this.monthsmap
        switch (data.type) {
          case 'image/png': {
            fname += '.png'
            break;
          }
          case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
            fname += '.docx'
            break;
          }
          case 'application/excel': {
            fname += '.xlsx'
            break;
          }
          case 'application/octet-stream': {
            fname += '.jpg'
            break;
          }
          case "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
            fname += '.pptx'
            break
          }
          case "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
            fname += '.ppt'
            break
          }
          case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
            fname += '.xls'
            break;
          }
          case 'application/octet-stream': {
            fname += '.jpg'
            break;
          }
          case 'image/jpeg': {
            fname += '.jpeg'
            break;
          }
          case 'text/plain': {
            fname += '.txt'
            break;
          }
          case 'application/pdf': {
            fname += '.pdf'
            break;
          }
          case 'image/jpg': {
            fname += '.jpg'
            break;
          }
          default: {
            break;
          }
        }

        this.utils.downloadFile(data, fname);

      }

    })
  }
  downloadMultipleFiles() {
    let attdata: any;
    let filesObj = {};
    let obj = {};
    obj = this.meetingData['meetings'];
    Object.keys(obj).forEach(key => {
      attdata = JSON.parse(obj[key]['attendance']);
    });
    filesObj['fileUUID'] = attdata ? attdata['document_a'] : null
    // if(attdata && attdata['document_a']!= "null"){
    this.submitdataSerivce.downloadExcelDatas(filesObj).subscribe(data => {
      if (!Array.isArray(data)) {
        let fname = this.distname + "district Meeting Report" + "_" + this.ay + this.monthsmap

        if (data.type == "application/pdf" || data.type == "application/octet-stream") {
          switch (data.type) {
            case 'image/png': {
              fname += '.png'
              break;
            }
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
              fname += '.docx'
              break;
            }
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
              fname += '.pptx'
              break
            }
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
              fname += '.ppt'
              break
            }
            case 'application/octet-stream': {
              // fname+='.jpg'
              fname += '.pdf'
              break;
            }
            case 'application/excel': {
              fname += '.xlsx'
              break;
            }
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
              fname += '.xls'
              break;
            }
            case 'image/jpeg': {
              fname += '.jpeg'
              break;
            }
            case 'text/plain': {
              fname += '.txt'
              break;
            }
            case 'application/pdf': {
              fname += '.pdf'
              break;
            }
            case 'image/jpg': {
              fname += '.jpg'
              break;
            }
            default: {
              break;
            }
          }

          this.utils.downloadFile(data, fname);

        } else {
          this.toastr.error("some exception occured")
        }


      }

    })
    // } else{
    // this.toastr.error("File Not Found")
    // }
  }
  downloadMultipleImage() {
    let attdata: any;
    let filesObj = {};
    let obj = {};
    obj = this.meetingData['meetings'];
    Object.keys(obj).forEach(key => {
      attdata = JSON.parse(obj[key]['attendance']);
    });
    filesObj['fileUUID'] = attdata ? attdata['image_a'] : null
    // if(attdata && attdata['image_a']!="null"){
    this.submitdataSerivce.downloadExcelDatas(filesObj).subscribe(data => {
      if (!Array.isArray(data)) {
        let fname = this.distname + "district Meeting Image" + "_" + this.ay + this.monthsmap
        switch (data.type) {
          case 'image/png': {
            fname += '.png'
            break;
          }
          case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
            fname += '.docx'
            break;
          }
          case 'application/excel': {
            fname += '.xlsx'
            break;
          }
          case "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
            fname += '.pptx'
            break
          }
          case "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
            fname += '.ppt'
            break
          }
          case 'application/octet-stream': {
            fname += '.jpg'
            break;
          }
          case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
            fname += '.xls'
            break;
          }
          case 'image/jpeg': {
            fname += '.jpeg'
            break;
          }
          case 'text/plain': {
            fname += '.txt'
            break;
          }
          case 'application/pdf': {
            fname += '.pdf'
            break;
          }
          case 'image/jpg': {
            fname += '.jpg'
            break;
          }
          default: {
            break;
          }
        }

        this.utils.downloadFile(data, fname);

      }

    })
    // } else{
    // this.toastr.error("Image Not Found")
    // }

  }



}

